import { IsReadStatus } from "../../../../reducers/is_read.reducers";

export class QueryResultsModel<T> {
    // fields
    items: T[];
    totalCount: number;
    isReadStatus: IsReadStatus[];
    errorMessage: string;
    totalPrice?: number;

    constructor(items: T[] = [],
                totalCount = 0,
                isReadStatus: IsReadStatus[] = [],
                errorMessage = '',
                totalPrice = 0) {
        this.items = items;
        this.totalCount = totalCount;
        this.isReadStatus = isReadStatus;
        this.totalPrice = totalPrice;
    }
}

export type OKResponse = {
    ok: boolean;
}